module.exports = __webpack_public_path__ + "img/calltrackingcode.0e483a0e.jpg";